import { render, staticRenderFns } from "./promot.vue?vue&type=template&id=79b2b22a&scoped=true&"
import script from "./promot.vue?vue&type=script&lang=js&"
export * from "./promot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b2b22a",
  null
  
)

export default component.exports